import { SET_LIABILITY_SUMMARY, SET_LIABILITY_TYPES, SET_LIABILITY_TYPE_SUMMARY, SET_LIABILITY_GROUPING } from '../constants/actionTypes'
import { AssetGroups } from '../constants/assetGroups'

const initialState = {
  liabilitySummary: [],
  liabilityTypes: [],
  liabilityTypeSummary: [],
  liabilityGroup: AssetGroups.TYPE
}

const liabilityInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIABILITY_SUMMARY:
      return Object.assign({}, state, {
        liabilitySummary: action.liabilitySummary
      })
    case SET_LIABILITY_TYPES:
      return Object.assign({}, state, {
        liabilityTypes: action.liabilityTypes
      })
    case SET_LIABILITY_TYPE_SUMMARY:
      return Object.assign({}, state, {
        liabilityTypeSummary: action.liabilityTypeSummary
      })
    case SET_LIABILITY_GROUPING:
      return Object.assign({}, state, {
        liabilityGroup: action.liabilityGroup
      })
    default:
      return state
  }
}

export default liabilityInfo
